"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootSaga = rootSaga;
const redux_saga_1 = require("redux-saga");
const saga_1 = require("./containers/core/shell/main/saga");
function* rootSaga() {
    yield [
        redux_saga_1.effects.fork(saga_1.activateTabSaga),
        redux_saga_1.effects.fork(saga_1.requestRemoveTabSaga),
        redux_saga_1.effects.fork(saga_1.openTabSaga),
        redux_saga_1.effects.fork(saga_1.removeTabSaga)
    ];
}
//# sourceMappingURL=saga.js.map